import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RiskScoreModel } from '@lmsModels';
import { LmsModalFrameComponent } from '@lmsSharedUI';
import { MdbModalRef } from 'src/lib/mdb5-adapted/public-api';
import { RiskScoresService } from '../risk-scores.service';

@Component({
  selector: 'app-risk-scores-edit-dialog',
  templateUrl: './risk-scores-edit-dialog.component.html',
  styleUrls: ['./risk-scores-edit-dialog.component.scss'],
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, LmsModalFrameComponent],
})
export class RiskScoresEditDialogComponent implements OnInit {
  riskScoreModel: RiskScoreModel = new RiskScoreModel();
  editRiskScoreForm: FormGroup;
  submitted: boolean = false;
  riskScorecardInfo: any;
  riskScorecard: any;

  constructor(
    public dialogRef: MdbModalRef<RiskScoresEditDialogComponent>,
    private formBuilder: FormBuilder,
    public riskScoreService: RiskScoresService,
  ) {
    this.riskScorecardInfo = this.riskScorecard;
  }

  ngOnInit(): void {
    this.editRiskScoreForm = this.formBuilder.group({
      parameterType: [this.riskScoreModel.parameterType, [Validators.required]],
      description: [this.riskScoreModel.description, [Validators.required]],
      score: [this.riskScoreModel.score, [Validators.required]],
    });

    this.riskScoreModel.parameterType = this.riskScorecardInfo.parameterType;
    this.riskScoreModel.description = this.riskScorecardInfo.description;
    this.riskScoreModel.score = this.riskScorecardInfo.score;
  }

  saveRiskScore() {
    this.submitted = true;
    var isValidData = true;

    console.log(this.riskScorecardInfo, '..... riskScorecard...');
    this.submitted = true;
    var isValidData = true;

    if (this.editRiskScoreForm.invalid) {
      isValidData = false;
      console.log('Form not valid...');
    }

    if (isValidData) {
      return this.dialogRef.close(this.riskScoreModel);
    }
  }

  close() {
    this.dialogRef.close();
  }

  get validateRiskScoreValues() {
    return this.editRiskScoreForm.controls;
  }

  omit_special_char(event: any) {
    let k;
    k = event.charCode; //         k = event.keyCode;  (Both can be used)
    return (k > 64 && k < 91) || (k > 96 && k < 123) || k == 8 || k == 32 || (k >= 48 && k <= 57);
  }
}
